const actTemplateParamsListActions = {
  ACT_TEMPLATE_PARAMS_LIST_INIT: 'ACT_TEMPLATE_PARAMS_LIST_INIT',
  ACT_TEMPLATE_PARAMS_LIST_SET: 'ACT_TEMPLATE_PARAMS_LIST_SET',
};
export default actTemplateParamsListActions;
